import React from 'react';
import { NavigationBar } from '../../organisms/shared/navigationBar/NavigationBar';
import { getDataByType } from '../../../utils/utils';
import { Stack } from '../../atoms/stack/Stack';
import LinkList from '../../organisms/sitemap/linkList/LinkList';
import Header from '../../organisms/shared/header/Header';
import Footer from '../../organisms/shared/footer/Footer';

export const Sitemap = ({
  hero,
  sections,
  menu,
  footer,
  siteUrls,
  location,
  locale,
  search,
  activeTab,
  t,
}) => {
  const tabs = getDataByType(sections, 'tabs')?.componentData;
  const links = getDataByType(sections, 'links')?.componentData;
  const pagination = getDataByType(sections, 'links')?.pagination;

  return (
    <Stack className="bg-white overflow-x-hidden min-h-[100vh] justify-between">
      <NavigationBar
        data={menu}
        location={location}
        locale={locale}
        search={search}
        t={t}
      />
      <Header minimized />
      <main>
        <LinkList
          title={hero.title}
          tabs={tabs}
          activeTab={activeTab}
          links={links}
          pagination={pagination}
          t={t}
        />
      </main>
      <Footer data={footer} siteUrls={siteUrls} />
    </Stack>
  );
};

Sitemap.propTypes = {};
